import { render, staticRenderFns } from "./AddSearchCampaignGeneral.vue?vue&type=template&id=140563ba"
import script from "./AddSearchCampaignGeneral.vue?vue&type=script&lang=js"
export * from "./AddSearchCampaignGeneral.vue?vue&type=script&lang=js"
import style0 from "./AddSearchCampaignGeneral.vue?vue&type=style&index=0&id=140563ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports